// i18n INIT
// Required here for Redux Saga: ensures i18n is loaded
import '@lib/ui/i18n';

import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';

import App from './app/app';
import { store } from './app/store';
import { initSentry } from './initializers/initSentry';

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
